module.exports = __webpack_public_path__ + "static/iphone2-faa74fc76dc6db1798d59651b8c61337.png";